import React, { useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react";
import "../scss/portrait.scss";

import { init } from "echarts";
import { round } from "mathjs";
import { cloneDeep, isEmpty } from "lodash";
import Empty from "@/component/empty";
import Color from "@/tool/color";
import { styled } from "@mui/system";
import { LinearProgress } from "@mui/material";
import moWelfare from "../store/wealfare";
import moIndex from "../../store";

interface IProps {
  list?: any[];
}
interface IState {}
let echartdom: any = null;

const Portrait = (props: IProps, state: IState) => {
  const { PerWelfareDistributionDate } = moWelfare;
  const { isMock } = moIndex;
  const [active, setActive] = useState<number>(0);
  const portRef = useRef<any>(null);
  const getExperience = (val: any) => {
    // eslint-disable-next-line max-len
    const list: any = val?.map((item: any, i: number) => {
      const items: any = {};
      items.name = item.label;
      items.value = item?.rate;
      return items;
    });
    return list;
  };
  const list = getExperience(PerWelfareDistributionDate);

  // 获取最大值下标
  const getMaxIndex = (arr: any) => {
    let index = 0;
    if (arr?.length > 0) {
      let max: any = arr[0]?.value;
      // 声明了个变量 保存下标值
      for (let i = 0; i < arr.length; i += 1) {
        if (max < arr[i].value) {
          max = arr[i].value;
          index = i;
        }
      }
    }
    return index;
  };

  const result = useMemo(() => {
    const rList = cloneDeep(list);
    const res: any = [];
    rList?.forEach((item: any) => {
      const items = { ...item };
      items.value = item.value * 100;
      if (item?.value > 0.001) {
        res.push(items);
      }
    });
    return res;
  }, [list]);

  const max = getMaxIndex(result);
  const colors: any = ["one", "two", "three", "four", "five", "six", "success"];

  const getList = result?.map((item: any) => {
    const items = item;
    items.value = round(item.value, 1);
    return items;
  });

  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(portRef.current);
    const option = {
      color: [
        Color.one,
        Color.two,
        Color.three,
        Color.four,
        Color.five,
        Color.six,
        Color.seven,
      ],
      // color: colors,
      tooltip: {
        show: false,
        trigger: "item",
      },
      legend: {
        show: false,
      },
      series: [
        {
          type: "pie",
          radius: ["80%", "90%"],
          // avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
            formatter: ["{c|{c}}%", "{b|{b}}"].join("\n"),
            rich: {
              b: {
                fontFamily: "Roboto",
                fontSize: "16px",
                color: Color.blackColor(0.65),
              },
              c: {
                fontSize: "20px",
                fontWeight: 500,
                color: Color.blackColor(0.85),
                fontFamily: "Roboto",
              },
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "20px",
              fontWeight: 500,
            },
          },
          labelLine: {
            show: false,
          },
          barWidth: 16,
          data: getList,
        },
      ],
    };
    echartdom.setOption(option, true);
    for (let i = 0; i < result?.length; i += 1) {
      echartdom.dispatchAction({
        type: "downplay", // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: i,
      });
    }
    echartdom.dispatchAction({
      type: "highlight", // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: max,
    });
    echartdom.on("mouseover", (e: any) => {
      for (let i = 0; i < result?.length; i += 1) {
        echartdom.dispatchAction({
          type: "downplay", // 突出高亮显示;
          seriesIndex: 0,
          dataIndex: i,
        });
      }
      echartdom.dispatchAction({
        type: "highlight", // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: e.dataIndex,
      });
      setActive(e.dataIndex);
    });
    echartdom.on("mouseout", (e: any) => {
      for (let i = 0; i < result?.length; i += 1) {
        echartdom.dispatchAction({
          type: "downplay", // 突出高亮显示;
          seriesIndex: 0,
          dataIndex: i,
        });
      }
      echartdom.dispatchAction({
        type: "highlight", // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: max,
      });
      setActive(max);
    });
  };

  useEffect(() => {
    setActive(max);
    if (!isEmpty(result)) {
      render();
    }
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  }, [PerWelfareDistributionDate]);

  const addMouseActive = (val: number) => {
    const portrait = init(portRef.current);
    for (let i = 0; i < result?.length; i += 1) {
      portrait.dispatchAction({
        type: "downplay", // 突出高亮显示;
        seriesIndex: 0,
        dataIndex: i,
      });
    }
    portrait.dispatchAction({
      type: "highlight", // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: val,
    });
  };
  const removeMouseActive = (val: number) => {
    const portrait = init(portRef.current);
    portrait.dispatchAction({
      type: "downplay", // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: val,
    });
    portrait.dispatchAction({
      type: "highlight", // 突出高亮显示;
      seriesIndex: 0,
      dataIndex: max,
    });
  };
  const DProgress = styled(LinearProgress)({
    width: "120px",
    height: "4px",
    borderRadius: "4px",
    backgroundColor: Color.blackColor(0.04),
  });
  return (
    <section className="welfare-budget-warp">
      <section>
        <span className="sub-title">人均福利预算分布</span>
      </section>
      {!isEmpty(result) ? (
        <section
          className="budget-item"
          style={{
            backgroundImage: isMock
              ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
              : "",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        >
          <section
            ref={portRef}
            className="portrait-item-02"
            style={{
              background: "none",
            }}
          />

          <section className="budget-scale">
            {result &&
              result?.map((item: any, i: any) => (
                <section
                  key={`${i.toString()}`}
                  className={
                    active === i ? "progres-hover-item" : "progress_0911"
                  }
                  onMouseEnter={() => {
                    addMouseActive(i);
                    setActive(i);
                  }}
                  onMouseLeave={() => {
                    removeMouseActive(i);
                    setActive(max);
                  }}
                >
                  <p>
                    <span>{item.name}</span>
                    <DProgress
                      variant="determinate"
                      value={round(item.value, 1)}
                      className={colors[i]}
                    />
                  </p>
                  <span className="value">{round(item.value, 1)}%</span>
                </section>
              ))}
          </section>
        </section>
      ) : (
        <Empty margin={"20px 0 0"} />
      )}
    </section>
  );
};

export default observer(Portrait);
